<template lang="pug">
  .ablilityGroupTable
    AbilityGroupDriverItems.ablilityGroupTable__wrapper
    AbilityGroupPhoneHailing.ablilityGroupTable__wrapper
    AbilityGroupCustomerItems.ablilityGroupTable__wrapper
    AbilityGroupDispatchItems.ablilityGroupTable__wrapper
    AbilityGroupUserManagement.ablilityGroupTable__wrapper
    AbilityGroupTransactionItems.ablilityGroupTable__wrapper
    AbilityGroupReservation.ablilityGroupTable__wrapper
    AbilityGroupMobilePayment.ablilityGroupTable__wrapper
    AbilityGroupAnnouncement.ablilityGroupTable__wrapper
    AbilityGroupUserDelete.ablilityGroupTable__wrapper
</template>
<script>
import AbilityGroupDriverItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupDriverItems'
import AbilityGroupTransactionItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupTransactionItems'
import AbilityGroupCustomerItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupCustomerItems'
import AbilityGroupReservation from '@/pages/manager/AbilityRadioGroup/AbilityGroupReservation'
import AbilityGroupDispatchItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupDispatchItems'
import AbilityGroupMobilePayment from '@/pages/manager/AbilityRadioGroup/AbilityGroupMobilePayment'
import AbilityGroupUserManagement from '@/pages/manager/AbilityRadioGroup/AbilityGroupUserManagement'
import AbilityGroupPhoneHailing from '@/pages/manager/AbilityRadioGroup/AbilityGroupPhoneHailing'
import AbilityGroupAnnouncement from '@/pages/manager/AbilityRadioGroup/AbilityGroupAnnouncement'
import AbilityGroupUserDelete from '@/pages/manager/AbilityRadioGroup/AbilityGroupUserDelete'

export default {
  components: {
    AbilityGroupDriverItems,
    AbilityGroupTransactionItems,
    AbilityGroupCustomerItems,
    AbilityGroupReservation,
    AbilityGroupDispatchItems,
    AbilityGroupMobilePayment,
    AbilityGroupUserManagement,
    AbilityGroupPhoneHailing,
    AbilityGroupAnnouncement,
    AbilityGroupUserDelete,
  },
}
</script>
<style lang="scss" scoped>
.ablilityGroupTable {
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  max-height: 85vh;
  overflow-y: auto;

  &__wrapper {
    margin-bottom: 10px;

    &:nth-child(2n + 1) {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/AblilityGroupTable.vue